var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avator c:row-center c:flex-nowrap",class:{ 'with-border': _vm.isManager, 'is-single': _vm.avatorChars.length === 1 }},[_vm._v("\n  "+_vm._s(_vm.avatorChars.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }